<div
	[ngStyle]="{ 'min-width': tamMinWidhtSibSidebar + 'px', width: tamWidhtSibSidebar + 'px' }"
	class="sub-sidebar"
>
	<div class="search mr-4 pt-2">
		<input
			type="text"
			id="searchClient"
			name="searchClients"
			[(ngModel)]="search"
			[placeholder]="textSubSidebar.search"
			class="input-app input-search"
			(ngModelChange)="emmitSearch($event)"
		/>
	</div>
	<div *ngIf="back || add || next" class="flex justify-between btns">
		<button *ngIf="back" class="btnBack" (click)="btnBack()">
			<img src="../../../../assets/icon/backBlack.svg" width="6px" alt="" srcset="" />
			{{ textSubSidebar.back }}
		</button>
		<button *ngIf="add" class="btnBack" (click)="btnaAdd()">
			<img src="../../../../assets/icon/addBlack.svg" width="6px" alt="" srcset="" />
			{{ textSubSidebar.add }}
		</button>
		<button *ngIf="next" class="btnBack" (click)="btnNext()">
			{{ textSubSidebar.next }}
		</button>
	</div>
	<div class="px-3 py-2" *ngIf="textTitle != '' && (back || add || next)">
		<span class="font-lato text-xl font-bold text-complementary-color-b">{{ textTitle }}</span>
	</div>
	<div
		class="container"
		[ngStyle]="calcTamHeightSidebar(tamHeightSibSidebar)"
		infiniteScroll
		[infiniteScrollDistance]="2"
		[infiniteScrollThrottle]="50"
		[infiniteScrollContainer]="selector"
		[fromRoot]="true"
		(scrolled)="onScroll()"
	>
		<ng-content select=".cards"></ng-content>
	</div>
</div>
